/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import RightCart from "./RightCard";
import ThePoints from "./Thepoints";
import Refundable from "./Refundabable";
import UserDetails from "./UserDetails";
import SelectCard from "./SelectCard";
import { useDispatch, useSelector } from "react-redux";
import defaultImage from "../../../src/Assets/fallbackimg_giftcard.png";
import Loader from "../Loader/Loader";
import axiosInstance from "../../Common/Axios/axiosInstance";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { onGetClientCapping } from "../../Store/Slices/clientCappingSlice";
import {
  ClientInfo,
  Dispatch,
  EarnPoint,
  formatPrice,
  GenerateToken,
  getImageUrl,
  GetMemberData,
  GetProdBudSumData,
  handleLimit,
  LoginReducerData,
  LoginV3Data,
  OnSwitchAccountSuccess,
  OrderData,
  RedeemPoint,
  SendMail,
  SendSms,
  showMaxMessg,
  SupplierCapping,
  trackEvent,
  V3Data,
  VendorData,
} from "../Utility/Utility";
import { onPostEarnPointReset } from "../../Store/Slices/earnPointSlice";
import { onGenerateTokenSubmitReset } from "../../Store/Slices/generateTokenSlice";
import { onPostVendorOrderReset } from "../../Store/Slices/vendorOrderSlice";
import { onPostOrderReset } from "../../Store/Slices/orderSlice";
import { decryptAES } from "../../Common/Axios/encrypt";
import { decryptURLParam } from "../../Common/Axios/encrypt";
import API from "../../Common/Endpoint/serviceConstrants";
import { onGetMail } from "../../Store/Slices/sendMailSlice";
import { useRef } from "react";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { getProductList } from "../../Store/Slices/productSlice";
import PurchaseLimitAlertTile from "../PurchaseLimitAlertTile/PurchaseLimitAlertTile";
import { onGetCustomerProduct } from "../../Store/Slices/customerProductSummarySlice";
import RewardWidget from "../RewardWidget/RewardWidget";
import warning from "../../Assets/warning2.png";
import ReedemType from "./ReedemType";
import { use } from "react";
import PurchaseLimitPill from "../Giftcards/PurchaseLimitPill";
import { map } from "jquery";

const Voucher = (productReducer) => {
  const navigate = useNavigate();
  const location = useLocation();
  const minDenomination = parseInt(
    productReducer?.productReducer?.clientProductDenomination?.map((item) => item.denomination).sort((a, b) => a - b)[0]
  );
  const v3Data = V3Data();
  const supplierCapping = SupplierCapping();
  const loginReducerData = LoginReducerData();
  const memberData = GetMemberData();
  const redeemPoint = RedeemPoint();
  const clientInfo = ClientInfo();
  const vendorData = VendorData();
  const generateToken = GenerateToken();
  const sendSms = SendSms();
  const translation = getTranslationData();
  const switchAccountData = OnSwitchAccountSuccess();
  // const productId = productReducer?.productReducerDisocount?.id;
  // const clientProductMapping = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer?.data?.[0]?.clientProductMapping
  // );

  const [points, setPoints] = useState(0);
  const [cash, setCash] = useState(0);
  const [orderJourneyStarted, setOrderJourneyStarted] = useState(false);
  const [convenienceFee, setConvenienceFee] = useState(0);
  const [gst, setGst] = useState(0);

  const productData = productReducer?.productReducer;
  const [loading, setLoading] = useState(false);
  const [updatedData, setUpdatedData] = useState([]);
  const [burnPoints, setBurnPoints] = useState(0);
  const [earnPoints, setEarnPoints] = useState(0);
  const [razorPayKey, setRazorPayKey] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 768);
  const [totalPayableAmount, setTotalPayableAmount] = useState(0);
  const productDetails = productReducer?.productReducer;
  const [finalPayableAmount, setFinalPayableAmount] = useState(0);
  const [stockOutDenominations, setStockOutDenominations] = useState();
  const [outOfStockLabel, setOutOfStockLabel] = useState([]);
  const [filterStockOutDenominations, setFilterStockOutDenominations] = useState([]);
  // const [selectedCard, setSelectedCard] = useState({});
  const clientConfigurations = clientInfo?.clientData?.clientConfigurations;
  const cardListData = useSelector((state) => state.clientConfigDataReducer);
  const isBurn = clientConfigurations?.find(
    (item) => item.configKey.toLowerCase() === "isburn"
  )?.configValue;

  const categoryAllData = useSelector(
    (state) => state.userRoleSliceReducer.categoryData
  );

  const catergoryData = categoryAllData.filter(
    (category) => category?.id === productReducer.productReducer?.categoryId
  );
  const supplierCappingList = useSelector(
    (state) => state?.clientCappingSliceReducer?.clientCappingData
  );
  const [quantities, setQuantities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const loginV3Data = LoginV3Data();
  const prodSumData = GetProdBudSumData();
  const [totalAmount, setTotalAmount] = useState();
  const dispatch = Dispatch();
  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    dispatch(onPostEarnPointReset());
    dispatch(onGenerateTokenSubmitReset());
    dispatch(onPostVendorOrderReset());
    dispatch(onPostOrderReset());
    setLoading(false);
  }, []);
  useEffect(() => {
    if (productReducer?.productReducer?.clientProductDenomination) {
      const clientProductDeno = productReducer?.productReducer?.clientProductDenomination;
      const productDeno = productReducer?.arrayData?.arrayData || productReducer?.modalProductData;
      if (productDeno) {
        const filterDeno = productDeno?.map(deno => {
          const match = clientProductDeno?.find(
            item => item?.denomination === deno.denomination
          );
          return match?.stockOut === true;
        });
        setOutOfStockLabel(filterDeno || []);
        const outOfStockDenominations = productDeno?.filter((deno, idx) => filterDeno?.[idx] === true);
        setFilterStockOutDenominations(outOfStockDenominations || []);
        setStockOutDenominations(filterDeno?.every((item) => item === true) || false);
      }
    }
  }, [productReducer?.productReducer?.clientProductDenomination, productReducer?.arrayData?.arrayData, productReducer?.modalProductData])
  useEffect(() => {
    getClientInfo();
    dispatch(onGetMail());
    trackEvent("page_browse", {
      page_title: productDetails?.name,
      page_url: window.location.href,
    });
  }, []);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const encryptedProductId = urlParams.get("productId");

    // Conditionally decrypt the productId parameter based on environment setting
    const productId = encryptedProductId
      ? process.env.REACT_APP_IS_ENCRYPTION_ENABLED === "false"
        ? encryptedProductId
        : decryptURLParam(encryptedProductId)
      : null;

    if (!productId) return;
    setIsLoading(true);
    if (
      supplierCappingList?.length === 0 ||
      supplierCappingList === undefined
    ) {
      dispatch(onGetClientCapping(parseInt(loginReducerData?.clientId)));
    }

    const payload = {
      productId: productId,
      pageNumber: 1,
      pageSize: 10,
    };
    dispatch(getProductList(payload))
      .then((res) => {
        if (res?.payload?.response?.products) {
          let product = res?.payload.response.products.find(
            (prod) => prod.id === parseInt(productId)
          );
          dispatch(setProduct(product));
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  // value.quantity
  useEffect(() => {
    let tempQuantity = [];
    if (productReducer?.arrayData?.arrayData) {
      productReducer?.arrayData?.arrayData?.map((value) => {
        return tempQuantity.push(value.quantity);
      });
      setQuantities(tempQuantity);
    } else {
      productReducer?.modalProductData?.map((value) => {
        return tempQuantity.push(value.quantity);
      });
      setQuantities(tempQuantity);
    }
  }, []);

  const updateQuantity = (index, change, value) => {
    const current = quantities[index];
    const next = current + change;

    const newQuantities = [...quantities];
    newQuantities[index] = Math.max(0, next);

    if (supplierCapping > 0 && next === supplierCapping) {
      showMaxMessg(translation.max_capping_allowed, supplierCapping, 1, value);
    }

    // Calculate totalDiscount
    let totalDiscount = 0;
    const discountPercent =
      productReducer?.productReducerDisocount?.customerDiscount || 0;
    const sourceData =
      productReducer?.arrayData?.arrayData ||
      productReducer?.modalProductData ||

      [];
    newQuantities.forEach((qty, idx) => {
      const denomination = sourceData[idx]?.denomination || 0;
      totalDiscount += ((denomination * discountPercent) / 100) * qty;
    });

    const eventItems = newQuantities.map((qty, idx) => {
      const denom = sourceData[idx]?.denomination || 0;
      const youPay = sourceData[idx]?.you_pay || 0;
      return {
        item_id: productReducer?.productReducer?.sku,
        item_brand: productReducer?.productReducer?.name,
        item_name: productReducer?.productReducer?.name,
        affiliation: "IDFC Store",
        item_category: "giftcard",
        item_category2: catergoryData?.[0]?.name || "",
        item_image: productReducer?.productReducer?.small,
        price: Number(youPay),
        gift_card_points: denom,
        quantity: qty,
        item_url: window?.location?.href,
      };
    });

    let basePayable = 0;
    newQuantities.forEach((qty, idx) => {
      const youPay = sourceData[idx]?.you_pay || 0;
      basePayable += (youPay || 0) * (qty || 0);
    });

    const productMapping = productReducer?.productReducer || {};
    const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
    const gstPercent = Number(productMapping?.gst) || 0;
    const convenienceFeeAmount = (basePayable * convenienceFeePercent) / 100;
    const gstAmount = (convenienceFeeAmount * gstPercent) / 100;
    const finalValue = basePayable + convenienceFeeAmount + gstAmount;

    const selectedCard = localStorage.getItem("RewardWidget");
    const cardData = cardListData?.clientConfigData?.cards?.find(
      (card) => card.cardId === selectedCard
    );
    let rewardPoints = 0;
    if (cardData) {
      rewardPoints = Math.floor(
        (finalValue / cardData.perRs) *
        cardData.standardPoints *
        (cardData.bonusPoints / cardData.standardPoints + 1)
      );
    }

    trackEvent("quantity_updated", {
      card_name: selectedCard,
      reward_points: rewardPoints,
      value: finalValue,
      total_gift_card_points: sourceData.reduce(
        (sum, item, idx) =>
          sum + (item.denomination || 0) * (newQuantities[idx] || 0),
        0
      ),
      discount: totalDiscount,
      currency: "INR",
      items: eventItems,
    });

    let updatedAppData =
      productReducer?.modalProductData ||
      productReducer?.arrayData?.arrayData?.map(function (item, index) {
        return { ...item, quantity: newQuantities[index] };
      });

    setPoints(0);
    setBurnPoints(0);
    navigate(location.pathname + location.search, {
      state: {
        arrayData: updatedAppData,
      },
      replace: true,
    });
    setQuantities(newQuantities);
  };

  useEffect(() => {
    const getSourceData = () => {
      const clientProductDenomination =
        productReducer?.productReducer?.clientProductDenomination;

      const sourceData =
        productReducer?.arrayData?.arrayData ||
        productReducer?.modalProductData;

      if (!sourceData || !clientProductDenomination) return [];

      const stockMap = new Map(
        clientProductDenomination.map(item => [
          item.denomination,
          item.stockOut
        ])
      );

      const filterDeno = sourceData.map(deno =>
        stockMap.get(deno.denomination) === true
      );

      setOutOfStockLabel(filterDeno || []);

      // 🔹 stockOut items
      const outOfStockDenominations = sourceData.filter(
        (_, idx) => filterDeno[idx]
      );

      setFilterStockOutDenominations(outOfStockDenominations || []);

      setStockOutDenominations(filterDeno.every(Boolean) || false);

      return sourceData.filter(
        deno => stockMap.get(deno.denomination) !== true
      );
    };

    const sourceData = getSourceData();
    const fullSourceData = productReducer?.arrayData?.arrayData || productReducer?.modalProductData || [];

    const updated = sourceData
      .map((value) => {
        // Find the original index in the full data to get correct quantity
        const originalIndex = fullSourceData.findIndex(item => item.denomination === value.denomination);
        const quantity = quantities[originalIndex] || 0;
        return {
          denomination: value.denomination,
          you_pay: value.you_pay,
          quantity,
          discountAmount:
            value.denomination * quantity -
            (value.denomination *
              quantity *
              (productReducer?.productReducer?.customerDiscount || 0)) /
            100,
          total: (value.you_pay * quantity).toFixed(2),
        };
      })
      .filter((item) => item.quantity > 0);
    setUpdatedData(updated);
    // Total amount calculation
    const productMapping = productReducer?.productReducer;
    // convenience fee % and gst %
    const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
    const gstPercent = Number(productMapping?.gst) || 0;
    // let totalDenomination = 0;
    // let totalQuantity = 0;
    let basePayableAmount = 0;
    let convenienceFeeAmount = 0;
    let gstAmount = 0;

    updated?.forEach((item) => {
      const qty = item.quantity || 0;
      // totalDenomination += item.denomination * qty;
      // totalQuantity += qty;
      basePayableAmount += item.you_pay * qty;
      const convPerItem = (item.you_pay * convenienceFeePercent) / 100;
      convenienceFeeAmount += convPerItem * qty;
      const gstPerItem = (convPerItem * gstPercent) / 100;
      gstAmount += gstPerItem * qty;
    });
    const totalPayableAmount =
      basePayableAmount + convenienceFeeAmount + gstAmount;
    setTotalAmount(totalPayableAmount);
  }, [quantities, productReducer]);

  useEffect(() => {
    let totalDenomination = 0;
    let totalQuantity = 0;
    let totalPayableAmount = 0;

    updatedData?.forEach((item) => {
      totalDenomination += item.denomination * item.quantity;
      totalQuantity += item.quantity;
      totalPayableAmount +=
        item.denomination * item.quantity -
        (item.denomination *
          item.quantity *
          (productReducer?.productReducer?.customerDiscount || 0)) /
        100;
    });
    setTotalPayableAmount(totalPayableAmount);
  }, [updatedData, productReducer, productReducer?.arrayData?.arrayData, productReducer?.modalProductData]);

  const currentBalance = useSelector((state) => state.cardDataSliceReducer?.pointBalance);
  const handleTotalPayableAmountChange = (amount) => {
    setTotalPayableAmount(amount - gst - convenienceFee);
  };
  const productLoading = useSelector((state) => state.productReducer);
  const productList =
    productReducer?.modalProductData ?? productReducer?.arrayData?.arrayData;

  const orderData = OrderData();
  const earnPoint = EarnPoint();
  const sendMailData = SendMail();
  const getClientInfo = async () => {
    try {
      const { data = {} } = await axiosInstance.get(API.clientpaymentid, {
        params: {
          clientId: clientInfo?.clientData?.id,
          mode: clientInfo?.clientData?.mode,
        },
        headers: {
          ...axiosInstance.defaults.headers,
          Encryption: 2,
        },
      });
      const key = decryptAES(data?.response?.[0]?.resourceValue);
      setRazorPayKey(key);
    } catch {
      return null;
    }
  };
  const hasTracked = useRef(false);
  // const calculateEarnPoints = (item) => {
  //   return Math.round(
  //     (minEarn / getMinPrice(priceDenominations)) *
  //     (item - (item * discount) / 100)
  //   );
  // };
  useEffect(() => {
    if (!hasTracked.current && quantities.length > 0) {
      // Always use the correct sourceData
      const sourceData =
        productReducer?.arrayData?.arrayData ||
        productReducer?.modalProductData ||
        [];
      let basePayable = 0;
      let totalDiscount = 0;
      const discountPercent =
        productReducer?.productReducerDisocount?.customerDiscount || 0;

      // compute base payable and discount using quantities (preserve index mapping)
      quantities.forEach((qty, idx) => {
        const denomination = sourceData[idx]?.denomination || 0;
        const youPay = sourceData[idx]?.you_pay || 0;
        basePayable += (youPay || 0) * (qty || 0);
        totalDiscount += ((denomination * discountPercent) / 100) * (qty || 0);
      });

      // include convenience fee and gst to match add_to_cart final value
      const productMapping = productReducer?.productReducer || {};
      const convenienceFeePercent = Number(productMapping?.convenienceFee) || 0;
      const gstPercent = Number(productMapping?.gst) || 0;
      const convenienceFeeAmount = (basePayable * convenienceFeePercent) / 100;
      const gstAmount = (convenienceFeeAmount * gstPercent) / 100;
      const finalValue = basePayable + convenienceFeeAmount + gstAmount;

      const selectedCard = localStorage.getItem("RewardWidget");
      const cardData = cardListData?.clientConfigData?.cards?.find(
        (card) => card.cardId === selectedCard
      );
      let rewardPoints = 0;
      if (cardData) {
        rewardPoints = Math.floor(
          (finalValue / cardData.perRs) *
          cardData.standardPoints *
          (cardData.bonusPoints / cardData.standardPoints + 1)
        );
      }
      // build items array only for qty > 0 and include per-item total price (you_pay * qty)
      const items = sourceData
        .map((item, idx) => {
          const qty = quantities[idx] || 0;
          if (!qty || qty <= 0) return null;
          return {
            item_brand: productReducer?.productReducer?.name,
            item_name: productReducer?.productReducer?.name,
            item_id: productReducer?.productReducer?.sku,
            affiliation: "IDFC Store",
            item_category: "giftcard",
            item_category2: catergoryData?.[0]?.name || "",
            item_image: productReducer?.productReducer?.small,
            gift_card_points: item?.denomination,
            quantity: qty,
            price: (item?.you_pay || 0) * qty,
            item_url: window?.location?.href,
          };
        })
        .filter(Boolean);

      // Only track if there is at least one quantity > 0
      if (productDetails && finalValue > 0) {
        trackEvent("begin_checkout", {
          currency: "INR",
          value: finalValue,
          total_gift_card_points: sourceData.reduce(
            (sum, item, idx) =>
              sum + (item.denomination || 0) * (quantities[idx] || 0),
            0
          ),
          discount: totalDiscount,
          card_name: selectedCard,
          reward_points: rewardPoints,
          items,
        });
        hasTracked.current = true;
      }
    }
  }, [productReducer, quantities, cardListData]);
  const loadingData =
    productLoading?.isLoading ||
    loading ||
    orderData?.isLoading ||
    vendorData?.isPostLoading ||
    earnPoint?.isPostLoading ||
    generateToken?.isLoading ||
    sendSms?.isPostLoading ||
    redeemPoint?.isPostLoading ||
    sendMailData?.isPostLoading ||
    switchAccountData?.isPostLoading;

  useEffect(() => {
    const finalAmount = Number(totalPayableAmount + convenienceFee + gst);
    setFinalPayableAmount(parseFloat(finalAmount.toFixed(2)));
    if (
      currentBalance === 0 ||
      isBurn === 2 ||
      productData?.maxEarnPoints === 0
    ) {
      setCash(Number(finalAmount.toFixed(2)));
    }
  }, [totalPayableAmount, convenienceFee, gst]);
  useEffect(() => {
    if (loginV3Data?.memberIdentifier) {
      dispatch(
        onGetCustomerProduct({
          customerId: loginV3Data.memberIdentifier,
          productIdentifier: productReducer.productReducer.id,
        })
      );
    }
  }, []);
  useEffect(() => {
    let totaDenAmount = updatedData.reduce((acc, crr) => {
      return acc + crr.denomination * crr.quantity;
    }, 0);
    handleLimit(
      totaDenAmount,
      prodSumData?.getCustomerProduct,
      dispatch,
      translation,
      productReducer?.productReducer?.productBudget?.limits
    );
  }, [finalPayableAmount]);
  // useEffect(() => {
  //   const selectedCard = () => {
  //     setSelectedCard(selectedCard)
  //   }
  // }, []);

  return (
    <>
      {loadingData || isLoading || prodSumData?.isLoading ? (
        <Loader />
      ) : (
        <div className="row">
          <div className="col-lg-8  ">
            <div className="row mx-0  py-3 cartGrid">
              <div className="col-lg-4 pe-0">
                <div className="d-flex w-100 h-100 justify-content-center">
                  <div>
                    <div className="w-100">
                      <img
                        className="w-144 card_main_image i-vch h-vch"
                        src={getImageUrl(productDetails?.mobile)}
                        alt="not-find"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-12 padding-50-1000-1400">
                <div className="row justify-content-between pb-2 mt-1">
                  <div className="col-12 col-md-auto lh-1 cart-f pt-md-1">
                    {productDetails?.name}
                  </div>
                </div>
                <div className="row">
                  <div className="col-8">
                    <span className="pro-discount">
                      {productReducer?.productReducerDisocount
                        ?.customerDiscount !== 0 &&
                        `Discount Flat ${productReducer?.productReducerDisocount?.customerDiscount}%`}
                    </span>
                    <span>
                      <ReedemType
                        status={
                          productReducer?.productReducer?.redeemableType || ""
                        }
                      />
                    </span>
                  </div>
                  <div className="col-4">
                    <PurchaseLimitPill />
                  </div>
                </div>
                <div
                  id="pricing-table-card"
                  className="pricing-table-card row mt-4"
                >
                  {/* Heading Row */}
                  <div className="heading-row col-lg-9">
                    <div className="heading">{translation?.value}</div>
                    <div className="heading1">{translation?.qty}</div>
                    <div className="heading">{translation?.youPay}</div>
                  </div>

                  {/* Data Rows */}
                  {productReducer?.arrayData?.arrayData
                    ? productReducer?.arrayData?.arrayData?.map(
                      (value, index) => (
                        <div
                          className="pricing-row col-lg-9 mb-2"
                          key={index}
                          style={outOfStockLabel[index] ? { opacity: 0.2 } : {}}
                        >
                          <div className="value">
                            ₹{value.denomination.toLocaleString()}
                          </div>
                          <div className="quantity">
                            {
                              <button
                                className={`quantity-btn-minus ${quantities[index] === 0
                                  ? "quantity-disabled"
                                  : ""
                                  }`}
                                onClick={() => updateQuantity(index, -1)}
                                disabled={quantities[index] === 0 || outOfStockLabel?.[index]}
                              >
                                -
                              </button>
                            }
                            <span className={`quantity-value `}>
                              {quantities[index]}
                            </span>
                            <button
                              className={`quantity-btn-plus  ${supplierCapping > 0 &&
                                quantities[index] === supplierCapping
                                ? "quantity-disabled"
                                : ""
                                }`}
                              onClick={() =>
                                updateQuantity(index, +1, value?.denomination)
                              }
                              disabled={
                                (supplierCapping > 0 &&
                                  quantities[index] === supplierCapping) ||
                                v3Data?.disable ||
                                outOfStockLabel?.[index]
                              }
                            >
                              +
                            </button>
                          </div>
                          <div className="price">
                            ₹
                            {formatPrice(
                              value.denomination * quantities[index] -
                              (value.denomination *
                                quantities[index] *
                                (productReducer?.productReducer
                                  ?.customerDiscount || 0)) /
                              100
                            )}
                          </div>
                        </div>
                      )
                    )
                    : productReducer?.modalProductData?.map((value, index) => (
                      <div className="pricing-row col-lg-9 mb-2" key={index} style={outOfStockLabel[index] ? { opacity: 0.2 } : {}}>
                        <div className="value">₹{value.denomination}</div>
                        <div className="quantity">
                          {
                            <button
                              className={`quantity-btn-minus ${quantities[index] === 0
                                ? "quantity-disabled"
                                : ""
                                }`}
                              onClick={() => updateQuantity(index, -1)}
                              disabled={quantities[index] === 0 || outOfStockLabel?.[index]}
                            >
                              -
                            </button>
                          }
                          <span className="quantity-value">
                            {quantities[index]}
                          </span>
                          <button
                            className={`quantity-btn-plus  ${supplierCapping > 0 &&
                              quantities[index] === supplierCapping
                              ? "quantity-disabled"
                              : ""
                              }`}
                            onClick={() =>
                              updateQuantity(index, +1, value.denomination)
                            }
                            disabled={
                              supplierCapping > 0 &&
                              quantities[index] === supplierCapping || outOfStockLabel?.[index]
                            }
                          >
                            +
                          </button>
                        </div>
                        <div className="price">
                          ₹
                          {formatPrice(
                            value.denomination * quantities[index] -
                            (value.denomination *
                              quantities[index] *
                              (productReducer?.productReducer
                                ?.customerDiscount || 0)) /
                            100
                          )}
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          {isMobileView && outOfStockLabel?.some((label) => label === true) && (
            <div className="SelectedDominationUnavailable mt-4">
              <div className="d-flex justify-content-center align-items-center text-left">
                <div className="availble-left">
                  <img src={warning} alt="Unavailable" className="mr-2" />
                </div>
                <div className="availble-right">
                  <div className="unavailable-text">
                    {translation?.stockout_message_title}
                    {/* {translation?.selectedDenominationUnavailable} */}
                  </div>
                  <p>{filterStockOutDenominations?.map(item => item.denomination).join(", ")}
                    {filterStockOutDenominations?.length > 1 ? ' are ' : ' is '}
                    {translation.stockout_message_desc}
                  </p>
                </div>
              </div>
            </div>
          )
          }
          <div className="col-lg-4 position-relative">
            {/* <div className="col-lg-4"> */}
            <div className="mt-3">
              <RewardWidget totalAmount={totalAmount} />
            </div>
            <RightCart
              productReducer={productReducer}
              updatedData={updatedData}
              setConvenienceFee={setConvenienceFee}
              setGst={setGst}
            />

            {v3Data?.disable && (
              <>
                <PurchaseLimitAlertTile
                  timePeriod={v3Data?.timePeriod}
                  amount={v3Data?.amount}
                  name={productReducer?.productReducer?.name}
                  reset_text={v3Data?.reset_text}
                />

                <div className="overlay-block position-absolute w-100 h-100 top-0 start-0"></div>
              </>
            )}
            {!isMobileView && outOfStockLabel?.some((label) => label === true) && (
              <div className="SelectedDominationUnavailable mt-4">
                <div className="d-flex justify-content-center align-items-center text-left">
                  <div className="availble-left">
                    <img src={warning} alt="Unavailable" className="mr-2" />
                  </div>
                  <div className="availble-right">
                    <div className="unavailable-text">
                      {translation?.stockout_message_title}
                      {/* {translation?.selectedDenominationUnavailable} */}
                    </div>

                    <p>{filterStockOutDenominations?.map(item => item.denomination).join(", ")}
                      {filterStockOutDenominations?.length > 1 ? ' are ' : ' is '} {translation.stockout_message_desc}</p>
                  </div>
                </div>
              </div>
            )
            }

            <SelectCard
              points={points}
              productReducer={productReducer}
              updatedData={updatedData}
              setEarnPoints={setEarnPoints}
            />

            {isBurn !== 2 &&
              productData?.maxEarnPoints > 0 &&
              currentBalance > 0 && (
                <ThePoints
                  cash={cash}
                  setCash={setCash}
                  points={points}
                  setPoints={setPoints}
                  productDataw={productReducer}
                  productReducer={productReducer?.productReducerDisocount}
                  updatedData={updatedData}
                  productData={productData}
                  onTotalPayableAmountChange={handleTotalPayableAmountChange}
                  setBurnPoints={setBurnPoints}
                  minDenomination={minDenomination}
                />
              )}
            <Refundable />
            <UserDetails
              points={points}
              cash={cash}
              setLoading={setLoading}
              totalPayableAmount={finalPayableAmount}
              quantities={quantities}
              stockOutDenominations={stockOutDenominations}
              productReducer={productReducer}
              updatedData={updatedData}
              productData={productData}
              burnPoints={burnPoints}
              earnPoints={earnPoints}
              razorPayKey={razorPayKey}
              setTotalPayableAmount={setTotalPayableAmount}
              setPoints={setPoints}
              setBurnPoints={setBurnPoints}
              convenienceFee={convenienceFee}
              gst={gst}
              currentBalance={currentBalance}
              disabled={v3Data?.disable}
              setOrderJourneyStarted={setOrderJourneyStarted}
            />
          </div>
        </div>
      )}

      {orderJourneyStarted && <Loader />}
    </>
  );
};
export default Voucher;
